import {
  API_APONTAMENTOS_PRODUCAO,
  API_COMPONENTES_PRODUTO,
  API_CONSUMO_MADEIRA,
  API_ETAPAS_PRODUCAO,
  API_ETIQUETAS_MODELOS,
  API_ITENS_ORDEM_PRODUCAO,
  API_MAQUINAS,
  API_ORDENS_PRODUCAO,
  API_PRODUCAO_DIMENSIONAL,
  API_TIPOS_MAQUINA,
} from '../api/apiConfig';
import {
  ApontamentoProducao,
  ComponenteProduto,
  ConsumoMadeira,
  EtapaProducao,
  ItemOrdemProducao,
  Maquina,
  OrdemProducao,
  ProducaoDimensional,
  TipoMaquina,
} from '../types/producao';
import { EtiquetaModelo } from '../types/etiquetas';
import { createCrudService } from './crudFactory';

export const componentesProdutoService =
  createCrudService<ComponenteProduto>(API_COMPONENTES_PRODUTO);
export const tiposMaquinaService = createCrudService<TipoMaquina>(API_TIPOS_MAQUINA);
export const maquinasService = createCrudService<Maquina>(API_MAQUINAS);
export const ordensProducaoService =
  createCrudService<OrdemProducao>(API_ORDENS_PRODUCAO);
export const itensOrdemProducaoService =
  createCrudService<ItemOrdemProducao>(API_ITENS_ORDEM_PRODUCAO);
export const etapasProducaoService =
  createCrudService<EtapaProducao>(API_ETAPAS_PRODUCAO);
export const apontamentosProducaoService =
  createCrudService<ApontamentoProducao>(API_APONTAMENTOS_PRODUCAO);
export const producaoDimensionalService =
  createCrudService<ProducaoDimensional>(API_PRODUCAO_DIMENSIONAL);
export const consumoMadeiraService =
  createCrudService<ConsumoMadeira>(API_CONSUMO_MADEIRA);
export const etiquetasModelosService =
  createCrudService<EtiquetaModelo>(API_ETIQUETAS_MODELOS);
